import { Service } from 'typedi';
import { ChangeSubmissionStatusModel, SubmissionListModel } from './SubmissionListModel';
import { BaseListViewModel } from '../../../../../core/services/BaseViewModel';
import { ISraService } from '../../SraService';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { Appl } from '../../../../../core/Appl';
import { ListItem } from '../../../../../core/services/BaseService';
import { ILovService } from '../../../utility/lov/LovService';
import Helper from '../../../../../core/services/Helper';

@Service() // eslint-disable-next-line
export default class SubmissionListViewModel extends BaseListViewModel<SubmissionListModel> {
  private service: ISraService;
  private lovService: ILovService;

  @observable public changeStatusModel: ChangeSubmissionStatusModel = {};
  @observable public submissionStatusList: Array<ListItem> = [];
  @observable public lovSubmissionStatus?: string = 'Submitted';
  @observable public searchText?: string = '';

  constructor() {
    super('Online Retirement Application Intake Queue', 'submissionId', false);
    this.service = Appl.Services.get<ISraService>('ISraService');
    this.lovService = Appl.Services.get<ILovService>('ILovService');
    makeObservable(this);
  }

  @action
  public async initAsync() {
    const submissionStatusResult = await this.lovService?.getListOfValuesAsync("scers_forms.lov_submission_status");
    if (submissionStatusResult.success) {
      runInAction(() => {
        this.submissionStatusList = submissionStatusResult.data;
      })
    }
  }

  public async getPagedAsync(): Promise<void> {
    const response = await this.service.getPagedAsync(`/retirement/Submission/search/1/${this.lovSubmissionStatus}`, this.searchRequest);
    await this.handleGetAllServerResponse(response);
  }

  @action
  public async onStatusChangeAsync(e: any): Promise<void> {
    this.lovSubmissionStatus = e.target?.value;
    await this.getPagedAsync();
  }

    @action
    public async export(format: string): Promise<void> {
      this.searchRequest = { skip: 0, take: 10000, sortColumn: this.searchRequest!.sortColumn, sortAscending: this.searchRequest!.sortAscending, filter: '' };
      const result = await this.service.getQueueAsFileAsync(format, this.searchRequest, this.lovSubmissionStatus);
      if (result.success) {
        Helper.downloadFile(result.data, 'ORA Intake Queue.csv', 'text/csv');
      } else {
        Appl.Error.handle(result.error);
      }
    }
    
}
